<div class="row config-block p-1">
    <div class="col-12">
        <h4 class="heading">Note</h4>
        <p>
            We've tailored the settings of our GPT Playground, including model, temperature and token length, to deliver
            an optimal user experience. It is recommended to adjust the settings before starting the conversation.
        </p>
    </div>


    <div class="col-12 mb-2" *ngIf="currentEnv != 'PROD'" >
        <div class="toggle-button">
            <input type="radio" id="azure" name="cloud" [checked]="config['chat_model']=='azure' || !config['chat_model']" (click)="chatModelChange('azure')" >
            <label for="azure">Azure</label>

            <input type="radio" id="gcp" name="cloud" (click)="chatModelChange('gcp')" [checked]="config['chat_model']=='gcp'">
            <label for="gcp">GCP</label>
        </div>
    </div>
    <div class="col-12" *ngIf="config['chat_model'] != 'gcp'">
        <app-range-slider [title]="'Temperature'" [value]="config.temperature" [min]="0" [max]="1" [step]="0.01"
            (valueChange)="handleValueChange($event)">
        </app-range-slider>
    </div>
    <div class="col-12 pt-3" *ngIf="config['chat_model'] != 'gcp'">
        <app-range-slider [title]="'Max length (token)'" [value]="config.max_tokens" [min]="5" [max]="4000" [step]="5"
            (valueChange)="handleValueChange1($event)">
        </app-range-slider>
    </div>
    <div *ngIf="config['chat_model'] != 'gcp'" class="col-12 pt-3" style="display: flex; font-size: 13px !important;">
        <span class="text-xs py-1">
            <a style="text-decoration: none;color: #012c45; "
                title="This guide shows you how we do style at Genpact. Have a read to make sure your writing looks like us."
                class="cursor-pointer"
                href="https://brand.genpact.com/brandsource/web/our-voice/writing-style-guide/some-rules-on-style"
                target="_blank">Genpact Style Guide</a>
        </span>
        <label class="checkbox-container">
            <input type="checkbox" [(ngModel)]="config.style_guide" (click)="handleValueChange3()">
            <span class="checkmark"></span>
        </label>
    </div>
    <div class="col-12 text-center pt-3">
        <button class="btn submit-config" (click)="submit()" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Submit</span>
            <span *ngIf="isSubmitting">
                <span class="spinner-border spinner-border spinner-border-sm text-primary" role="status"
                    aria-hidden="true"></span>
                Saving...
            </span>
        </button>
    </div>
</div>